import * as React from 'react';
import {IInputFieldProps} from '~/components/Form';
import {classByIntent} from '~/lib/intent';
import style from './index.module.scss';

export interface ICheckboxProps extends IInputFieldProps<boolean>, Omit<React.HTMLAttributes<HTMLInputElement>, 'onChange'> {
    toggle?: boolean;
    variant?: 'default' | 'primary';
    label?: React.ReactNode;
}

export function CheckboxInput({disabled, value, onChange, toggle, intent, className, variant = 'default', label}: ICheckboxProps) {
    const isChecked = !!value;
    let classes = [style.checkbox, classByIntent(intent), className];
    if (disabled) {
        classes.push(style.disabled);
    }
    if (isChecked) {
        classes.push(style.checked);
    }
    if (variant === 'primary') {
        classes.push(style.checkboxPrimary);
    }

    const iconPrefix = toggle ? 'far' : (isChecked ? 'fas' : 'far');
    const iconName = toggle
        ? (isChecked ? 'toggle-on' : 'toggle-off')
        : (isChecked ? 'check-square' : 'square');

    const toggleValue = () => onChange?.(!value);

    const box = <div className={classes.join(' ')}>
        <i className={`${iconPrefix} fa-${iconName}`} onClick={label === undefined ? toggleValue : undefined} />
    </div>;

    if (label === undefined) {
        return box;
    }

    return <label className={style.labeled} onClick={toggleValue}>
        {box}
        {label}
    </label>;
}
